// import VueI18n from 'vue-i18n'
import { createI18n } from 'vue-i18n'
// import i18nMessages from './lang'

import nb from './lang/nb.json'
import en from './lang/en.json'
import it from './lang/it.json'
import fr from './lang/fr.json'
import ro from './lang/ro.json'
import sv from './lang/sv.json'
import pt from './lang/pt.json'
import es from './lang/es.json'

const i18nMessages = {
  en,
  nb,
  it,
  fr,
  ro,
  sv,
  pt,
  es
}

console.log('i18nMessages')

const defaultLanguage = 'nb'
const i18n = createI18n({
  locale: defaultLanguage, // set locale
  fallbackLocale: 'en',
  messages: {
    'nb-NO': i18nMessages.nb,
    nb: i18nMessages.nb,
    en: i18nMessages.en,
    'en-GB': i18nMessages.en,
    it: i18nMessages.it,
    fr: i18nMessages.fr,
    ro: i18nMessages.ro,
    sv: i18nMessages.sv,
    pt: i18nMessages.pt,
    es: i18nMessages.es
  } // set locale messages
})

export default i18n
